import { render, staticRenderFns } from "./AdminUtilityReindexUser.vue?vue&type=template&id=96b0b56e"
import script from "./AdminUtilityReindexUser.vue?vue&type=script&lang=ts"
export * from "./AdminUtilityReindexUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports